import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "62",
      cy: "100",
      r: "36"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "62",
      cy: "100",
      r: "14",
      fill: "var(--mc-avatar)"
    }, null, -1),
    _createElementVNode("path", { d: "M98 92h80v16H98zM150 108h10v20h-10zM170 108h8v14h-8z" }, null, -1)
  ]))]))
}
export default { render: render }